import React from 'react'
import Alert from 'react-bootstrap/Alert'

export default props =>
    <Alert variant={props.color}>
        {props.content}<Alert.Link href={props.linkHref}>{props.link}</Alert.Link>
    </Alert>